import { render } from "./BookToEmptyBookshelfIllustration.vue?vue&type=template&id=16c17e5c"
import script from "./BookToEmptyBookshelfIllustration.vue?vue&type=script&lang=js"
export * from "./BookToEmptyBookshelfIllustration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__